module.exports = __webpack_public_path__ + "img/1.b53c0c30.png";